import { INewUserOwnProduct } from '../../../interfaces/OwnTractor.interfaces';
import { customAxios } from '../../common/customAxios';
import { usersOwnTractorsApiUrl } from './getUsersOwnTractors';

export const getNewUsersOwnProduct = (): Promise<INewUserOwnProduct> => {
  return customAxios.get(`${usersOwnTractorsApiUrl}/new-tractor`);
};
